import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField,
} from '@mui/material';

/**
 * [교체함] 확인 - window.confirm 대신 다이얼로그(다른 eqpmng 화면과 같은 패턴). 확인하면 누적을 0으로
 * 되돌린다(서버가 LAST_RESET_DT를 지금으로 갱신). 메모는 선택.
 */
const EqpToolResetDialog = ({ open, tool, submitting, onClose, onConfirm }) => {
  const [rmk, setRmk] = useState('');

  useEffect(() => {
    if (open) setRmk('');
  }, [open]);

  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>T{tool?.toolNo} 교체 처리</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          지금 시각으로 교체 기록을 남기고, 누적 가공시간·장착 횟수를 0부터 다시 셉니다. 되돌릴 수 없습니다.
        </DialogContentText>
        <TextField
          label="메모(선택)" value={rmk} fullWidth multiline minRows={2}
          onChange={(e) => setRmk(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>취소</Button>
        <Button onClick={() => onConfirm({ rmk: rmk || null })} variant="contained" color="warning" disabled={submitting} autoFocus>
          교체함
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EqpToolResetDialog;
